/**
 * The colleague's first name from a profile `displayName`, for the welcome line.
 * Handles "First Last", "Last, First" and a trailing " - Org" suffix; undefined when there is none.
 */
export function firstName(displayName: string | undefined): string | undefined {
	const name = displayName?.split(" - ")[0]?.trim();
	if (!name) return undefined;
	const [last, first] = name.split(",").map((part) => part.trim());
	return (first || last || name).split(/\s+/)[0] || undefined;
}
